import { Checkbox, Chip, IconButton, TableCell, TableRow, Tooltip } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { formatDate } from "../../utils/formatters";

const ObligoCell = ({ hasObligoException }) => (
  <TableCell align="center" onClick={(e) => e.stopPropagation()}>
    <Tooltip title={hasObligoException ? "קיימת חריגת אובליגו" : "אין חריגת אובליגו"}>
      <span>
        <Checkbox
          size="small"
          checked={hasObligoException}
          disabled
          sx={{ p: 0, "&.Mui-disabled": { color: hasObligoException ? "#dc2626" : "#c7c7c7" } }}
        />
      </span>
    </Tooltip>
  </TableCell>
);

// Collapsed line of an order in the orders table; clicking toggles the details.
const OrderSummaryRow = ({ order, open, onToggle }) => (
  <TableRow
    hover
    sx={{
      cursor: "pointer",
      transition: "background 0.2s",
      bgcolor: open ? "#f0f7ff" : "transparent",
      "& > *": { borderBottom: open ? "none" : "1px solid rgba(0,0,0,0.06)" },
    }}
    onClick={onToggle}
  >
    <TableCell sx={{ width: 48, pr: 0 }}>
      <IconButton size="small" sx={{ color: "#0054A5" }}>
        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </IconButton>
    </TableCell>
    <TableCell sx={{ fontWeight: 600, color: "#0054A5" }}>{order.ORDNAME}</TableCell>
    <TableCell>{order.CDES}</TableCell>
    <TableCell>{formatDate(order.CURDATE)}</TableCell>
    <TableCell>{formatDate(order.NEO_DUEDATE)}</TableCell>
    <TableCell>{order.AGENTNAME}</TableCell>
    <ObligoCell hasObligoException={order.NEO_OBLIGOEXIST === "Y"} />
    <TableCell>
      <Chip
        label={order.ORDSTATUSDES}
        size="small"
        sx={{ bgcolor: "#fff3e0", color: "#e65100", fontWeight: 600, fontSize: "0.72rem" }}
      />
    </TableCell>
  </TableRow>
);

export default OrderSummaryRow;
